
import Menu from '@/components/menu/menu.vue'
import { ElForm } from 'element-ui/types/form'
import { getHotelList } from '@/api/hotel'

// 导入对账单api
import { getbill, importbill, getFinancial, getMatch, putMatch } from '@/api/ota'

import Vue from 'vue'
export default Vue.extend({
	components: {
		Menu,
	},
	data() {
		var check_pms_hotel_code = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('PMS酒店code不能为空'))
			}
			if (value.length < 8 || value.length > 10) {
				return callback(new Error('PMS酒店code长度为8-10'))
			}
			callback()
		}
		var check_sale_room_code = (rule, value, callback) => {
			let ischannel = (this as any).src_channel == '携程'
			if (!value && ischannel) {
				return callback(new Error('产品code不能为空'))
			}
			if ((value.length < 5 || value.length > 12) && ischannel) {
				return callback(new Error('产品code长度为5-12'))
			}
			callback()
		}
		return {
			timer: null as any,
			importStatus: false,
			total: 0,
			percentagenum: 0,
			importInfoDia: false,
			pms_room_code_list: [] as any,
			showInfo2: true,
			hotels: [] as any, // 酒店选项
			status: [
				{
					id: 0,
					name: '全部',
				},
				{
					id: 1,
					name: '使用中',
				},
				{
					id: 2,
					name: '已停用',
				},
			],
			searchForm: {
				settlement_date: '',
				hotel_id: '',
			},
			editHotelDialog: false,
			hotel_submit_form: {
				date: '',
			},
			hotel_submit_form_rules: {
				date: [{ required: true, message: '请选择账单周期', trigger: 'blur' }],
				hotel_code: [{ required: true, message: '请输入酒店code', trigger: 'blur' }],
				hotel_id: [{ required: true, message: '请选择酒店', trigger: 'change' }],
				pms_hotel_id: [{ required: true, message: '请输入PMS酒店id', trigger: 'blur' }],
				ar_number: [
					{
						validator: (rule, value, callback) => {
							if (!value) {
								return callback(new Error('PMS应收账户的客户号不能为空'))
							}
							if (value.length < 1 || value.length > 5) {
								return callback(new Error('产品code长度为1-5'))
							}
							callback()
						},
						required: true,
						trigger: 'blur',
					},
				],
				pms_company_code: [
					{
						validator: (rule, value, callback) => {
							if (!value) {
								return callback(new Error('PMS公司代码不能为空'))
							}
							if (value.length < 1 || value.length > 5) {
								return callback(new Error('PMS公司代码长度为1-5'))
							}
							callback()
						},
						required: true,
						trigger: 'blur',
					},
				],
				pms_hotel_code: [{ validator: check_pms_hotel_code, trigger: 'blur' }],
			},
			hotel_submit_form_title: '',

			room_type_form: {
				hotel_id: '',
				bank_name: '',
				bank: '',
				bank_card: '',
			},
			room_type_form_rules: {
				pms_room_code: [{ required: true, message: '请输入PMS房型名称', trigger: 'change' }],
				sale_room_name: [{ required: true, message: '请输入房型名称（产品）', trigger: 'blur' }],
				sale_room_code: [{ validator: check_sale_room_code, trigger: 'blur' }],
				sale_type: [{ required: true, message: '请选择售卖类型', trigger: ['change', 'blur'] }],
			},
			editRoomDialog: false,
			room_type_form_title: '',
			orderStauts: '1',
			table_data: [],
			table_state: {
				loading: false,
			},
			src_channel: '美团',
			old_ding_secret: '',
			old_ding_webhook: '',

			page: 1,
			limit: 10,
			pickerOptions: {
				disabledDate(time) {
					const FullYear = time.getFullYear()
					let myDate = new Date()
					// const Month = time.getMonth() + 1
					if (FullYear < 2021) {
						return true
					} else {
						let t = myDate.getDate()
						// 如果想包含本月本月 - 8.64e7 * t 就不需要了，
						// 如果想之前的不能选择把 > 换成 <
						return time.getTime() > Date.now() - 8.64e7 * t
					}
					// return false
				},
			},
			currentMonth: new Date(),
			prevMonth: '' as any,
			prevMonthYear: '' as any,
			noMatchHotelList: [] as any,
			infotitle: '',
			selectHotelsDia: false,
			selectHotels_form: {
				formList: [],
			} as any,
		}
	},
	computed: {
		topMenuList() {
			const param = [
				// {
				// 	name: '携程订单',
				// 	value: '1',
				// 	info: '携程',
				// 	disabled: false,
				// 	id: '1',
				// },
				{
					name: '美团订单',
					value: '3',
					info: '美团',
					disabled: false,
					id: '2',
				},
				{
					name: '马蜂窝订单',
					value: '2',
					info: '马蜂窝',
					disabled: true,
					id: '4',
				},
				{
					name: '同城订单',
					value: '待定',
					info: '马蜂窝',
					disabled: true,
					id: '3',
				},
				{
					name: '飞猪订单',
					value: '4',
					info: '飞猪',
					disabled: true,
					id: '5',
				},
				{
					name: '驴妈妈订单',
					value: '驴妈妈',
					info: '5',
					disabled: true,
					id: '6',
				},
				{
					name: '途牛订单',
					value: '6',
					info: '途牛',
					disabled: true,
					id: '7',
				},
			]
			if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
				return param
			} else {
				return param.slice(0, 1)
			}
		},
		returnChannelinfo() {
			return (info, channelStr) => {
				return info.replaceAll('携程', channelStr)
			}
		},
	},
	created() {
		this.handleMonthChange()
		this.searchForm.settlement_date = this.prevMonthYear + '-' + this.prevMonth
		getHotelList().then((res) => {
			if (res.code == 0) {
				// 超级管理员/ota管理员有全部权限
				if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
					this.hotels = [{ id: 0, name: '全部' }].concat(res.data.rows)
				} else {
					this.hotels = res.data.rows
				}
				this.getChannelBill()
				this.getNoMatchInfo()
			}
		})
	},
	methods: {
		getNoMatchInfo() {
			getMatch().then((res) => {
				if (res.code == 0) {
					if (!Array.isArray(res.data)) {
						this.selectHotels_form.formList = []
						this.noMatchHotelList = Object.entries(res.data).map((item) => {
							this.selectHotels_form.formList.push({
								hotel_id: '',
								bill_code: item[0],
								hotel_name: item[1],
							})
							return {
								...item,
							}
						})
						// console.log(this.noMatchHotelList)
						this.infotitle = `当前万澳会平台有${this.noMatchHotelList.length}家酒店未能与美团酒店匹配成功，无法生成账单，请人工处理匹配信息`
					} else {
						this.noMatchHotelList = []
					}
				}
			})
		},
		selectHotels() {
			this.selectHotelsDia = true
		},
		handleMonthChange() {
			const date = new Date(this.currentMonth)
			date.setMonth(date.getMonth() - 1)

			this.prevMonthYear = date.getFullYear()
			this.prevMonth = (date.getMonth() + 1).toString().padStart(2, '0')
		},
		// 获取当前渠道对账单
		getChannelBill() {
			this.table_state.loading = true
			getbill({
				...this.searchForm,
				src_channel: this.src_channel,
				page: this.page,
				limit: this.limit,
			})
				.then((res) => {
					if (res.code == 0) {
						this.total = res.count
						this.table_data = res.data.map((item) => {
							let { hotel_id } = item
							let hotel = this.hotels.find((item2) => {
								return item2.id == hotel_id
							})
							return {
								...item,
								hotel_name: hotel ? hotel.name : '',
								pms_hotel_code: hotel ? hotel.miccode : '',
								complex: hotel ? hotel.complex : '',
							}
						})
					}
				})
				.finally(() => {
					this.table_state.loading = false
				})
		},
		changePages(data) {
			this.page = data
			this.getChannelBill()
		},
		changeLimit(data) {
			this.page = 1
			this.limit = data
			this.getChannelBill()
		},
		importInfo() {
			this.importStatus = false
			this.percentagenum = 0
			clearInterval(this.timer)
			this.importInfoDia = true
		},

		// 跳转账单明细
		checkaccount(row) {
			this.$router.push({
				name: 'account_detail',
				query: {
					billcode: row.bill_code,
					editstatus: '1',
					pms_hotel_code: row.pms_hotel_code,
					complex: row.complex,
					settlement_date: row.settlement_date,
					hotelname: row.hotel_name,
				},
			})
		},
		// 切换 订单类型
		changeChannelTab(data) {
			this.src_channel = data.info

			// console.log(data)

			// this.changeTypeTab({ value: this.orderStauts })
		},
		search(e) {
			// let find = this.hotels.find((item) => {
			// 	return item.id == e
			// })
			// if (find) {
			// 	this.searchForm.pms_hotel_code = find.miccode
			// }
			// this.changeTypeTab({ value: this.orderStauts })
			this.getChannelBill()
		},

		// 酒店编辑
		hotelEdit(row) {
			this.$router.push({
				name: 'account_detail',
				query: {
					billcode: row.bill_code,
					editstatus: '2',
					pms_hotel_code: row.pms_hotel_code,
					complex: row.complex,
					settlement_date: row.settlement_date,
					hotelname: row.hotel_name,
				},
			})
		},

		// 关闭dia重置表单
		closeHotelDialog() {
			this.hotel_submit_form = {
				date: '',
			}
		},
		closeRoomDialog() {
			this.room_type_form = {
				hotel_id: '',
				bank_name: '',
				bank: '',
				bank_card: '',
			}
			;(this.$refs['room_form'] as ElForm).clearValidate()
		},
		roomEdit(row) {
			this.room_type_form_title = '收款账户信息'
			// this.editRoomDialog = true
			let { hotel_id } = row
			getFinancial({
				hotel_id,
			}).then((res) => {
				if (res.code == 0) {
					console.log(res)
					let info = res.data[0]
					this.room_type_form = { ...info }
					this.editRoomDialog = true
				}
			})
		},

		resetForm(formName: string) {
			this.$nextTick(() => {
				;(this.$refs[formName] as ElForm).resetFields()
			})
		},
		submitForm(formName: string) {
			;(this.$refs[formName] as ElForm).validate((valid) => {
				if (valid) {
					if (formName == 'import_form') {
						this.importStatus = true
						this.setProgress()
						importbill({
							src_channel: this.src_channel,
							settlement_date: this.hotel_submit_form.date,
						})
							.then(
								(res) => {
									if (res.code == 0) {
										clearInterval(this.timer)
										this.percentagenum = 100
										this.$message({
											type: 'success',
											message: res.msg,
										})
										this.getChannelBill()
										this.getNoMatchInfo()
									}
								},
								(err) => {
									clearInterval(this.timer)
								}
							)
							.finally(() => {
								this.importInfoDia = false
							})
					}

					if (formName == 'selectHotels_form') {
						console.log(this.selectHotels_form)
						putMatch({
							list: this.selectHotels_form.formList,
						})
							.then((res) => {
								if (res.code == 0) {
									this.$message({
										type: 'success',
										message: res.msg,
									})
									this.getNoMatchInfo()
									this.getChannelBill()
								}
							})
							.finally(() => {
								this.selectHotelsDia = false
							})
					}
				} else {
					return false
				}
			})
		},
		setProgress() {
			this.timer = setInterval(() => {
				if (this.percentagenum <= 96) {
					this.percentagenum += 2
				} else {
					clearInterval(this.timer)
				}
			}, 1000)
		},
		changeTypeTab(e) {
			this.orderStauts = e.value
			// if (e.value == '1') {
			// 	this.methodsGetHotelList()
			// } else {
			// 	this.methodsGetHotelroomlist()
			// }
		},
	},
})
